/* eslint-disable
    eqeqeq,
    no-empty,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { isEmbeddedInMSTeams } from '@trello/browser';
import { clientVersion } from '@trello/config';
import { getMilliseconds } from '@trello/time';
import {
  browserSupportsWebSockets,
  webSocketState,
  WebSocketState,
  webSocketEvents,
} from '@trello/web-sockets';

import { featureFlagClient } from '@trello/feature-flag-client';
import { Analytics } from '@trello/atlassian-analytics';
import { monitor, monitorStatus } from '@trello/monitor';

const DONT_COME_BACK_CODE = 4001;
const TERMINATED_SESSION_CODE = 4002;

const randomWait = (wait: number, spread: number): number => {
  return Math.floor(wait + Math.random() * spread);
};

const calculateReconnectDelay = (event?: CloseEvent) => {
  const status = monitor.getStatus();
  const slowMs =
    status === 'active'
      ? randomWait(
          getMilliseconds({ seconds: 10 }),
          getMilliseconds({ seconds: 30 }),
        )
      : randomWait(
          getMilliseconds({ seconds: 30 }),
          getMilliseconds({ minutes: 2 }),
        );
  const fastMs =
    status === 'active'
      ? randomWait(100, getMilliseconds({ seconds: 1 }))
      : randomWait(
          getMilliseconds({ seconds: 2 }),
          getMilliseconds({ seconds: 10 }),
        );

  if (!event || event.code === 1006) {
    // We caused the disconnection or a hard crash of the proc, respectively
    // Let's take it slow
    return slowMs;
  } else if (event.code === 4000) {
    let seconds;
    try {
      // eslint-disable-next-line radix
      seconds = parseInt(event.reason, 0);
    } catch (error) {
      return fastMs;
    }
    if (status === 'active') {
      return randomWait(
        getMilliseconds({ seconds }),
        getMilliseconds({ seconds }) * 4,
      );
    } else {
      return randomWait(
        getMilliseconds({ seconds }) * 4,
        getMilliseconds({ seconds }) * 4 * 4,
      );
    }
  } else {
    return fastMs;
  }
};

export class Socket {
  static PING_TIMEOUT = 30000;
  static WAKE_UP_CHECK_INTERVAL = 2 * 1000;
  static MAX_RECONNECT_DELAY = 64000;
  static FAILED_CONSECUTIVE_RECONNECTS_LIMIT = 10;
  static RECONNECT_RATE_LIMIT = 3;
  static RECONNECT_RATE_WINDOW = getMilliseconds({ minutes: 5 });
  static MAX_RECONNECTS_PER_DAY = 100;

  url: string;
  ws: WebSocket | null;
  mustNeverReconnect: boolean;
  reconnectRateAttempts: number;
  totalReconnects: number;
  buffer: string[];
  connectedOnce: boolean;
  wakeUpCheckLastRun: number;
  failedConsecutiveReconnectAttempts: number;
  connectAttemptStarted: number;
  currentReconnectDelay: number;
  focusReconnectStarted: number;
  monitorUnsubscribe?: () => void;

  reconnectNotAttemptedReason?: string;
  previousReason: string;

  _wakeUpCheck: number;
  _dailyFailsCheck: number;
  _pingTimeout: number | null;
  _timeoutBackoff: number;
  _reconnectTimer: number | null;

  _timeoutBackOff?: number;

  constructor(url: string) {
    this.url = url;
    this.ws = null;

    this.resetRetries();

    webSocketEvents.listenTo(webSocketEvents, 'close', this.onClose.bind(this));
    webSocketEvents.listenTo(webSocketEvents, 'error', this.onError.bind(this));
    webSocketEvents.listenTo(
      webSocketEvents,
      'message',
      this.onMessage.bind(this),
    );
    webSocketEvents.listenTo(webSocketEvents, 'open', this.onOpen.bind(this));

    if (!browserSupportsWebSockets()) {
      webSocketEvents.trigger('connect_failed');
      return;
    }

    this.mustNeverReconnect = false;

    this.reconnectRateAttempts = 0;
    this.totalReconnects = 0;
    this.focusReconnectStarted = 0;

    this._setDailyFailsCheck();

    this.connect();

    this.buffer = [];
    this.connectedOnce = false;

    this.wakeUpCheckLastRun = Date.now();

    this._wakeUpCheck = window.setInterval(() => {
      const currentTime = Date.now();
      // consider we just woke up if the last time we ran this interval, which
      // is supposed to run every two seconds, was more than [rate limit
      // window in ms] ago

      const connectivityEnhancementsIsEnabled = featureFlagClient.get(
        'fep.connectivity-enhancements',
        false,
      );
      const forcefullyDisconnected = !connectivityEnhancementsIsEnabled
        ? this.mustNeverReconnect
        : webSocketState.value === WebSocketState.FORCE_DISCONNECTED;

      if (
        currentTime > this.wakeUpCheckLastRun + Socket.RECONNECT_RATE_WINDOW &&
        !forcefullyDisconnected
      ) {
        this.disconnect();
        this.reconnect();
      }
      this.wakeUpCheckLastRun = currentTime;
    }, Socket.WAKE_UP_CHECK_INTERVAL);

    webSocketEvents.trigger('connecting');
    webSocketEvents.on('reconnect_now', this.reconnectNow.bind(this));
  }

  _setDailyFailsCheck() {
    this._dailyFailsCheck = window.setInterval(() => {
      this.totalReconnects = 0;
      if (webSocketState.value === WebSocketState.CLOSED) {
        this.reconnect();
      }
    }, 86400000); // 1 day in ms
  }

  _setReconnectBackOff() {
    if (this._timeoutBackOff != null) {
      return;
    }

    this._timeoutBackOff = window.setTimeout(() => {
      clearTimeout(this._timeoutBackOff);
      delete this._timeoutBackOff;

      this.reconnectRateAttempts = 0;

      if (webSocketState.value === WebSocketState.CLOSED) {
        this.reconnect();
      }
    }, Socket.RECONNECT_RATE_WINDOW);
  }

  resetRetries() {
    this.failedConsecutiveReconnectAttempts = 0;
  }

  _clearPingTimeout() {
    if (this._pingTimeout != null) {
      clearTimeout(this._pingTimeout);
    }
    this._pingTimeout = null;
  }

  _resetPingTimeout() {
    this._clearPingTimeout();
    this._pingTimeout = window.setTimeout(
      this._noPing.bind(this),
      Socket.PING_TIMEOUT,
    );
  }

  _noPing() {
    if (!(webSocketState.value === WebSocketState.CONNECTED)) {
      return;
    }
    this.disconnect();
  }

  connect() {
    if (this.ws != null) {
      this.ws.onclose = null;
      this.ws.onerror = null;
      this.ws.onmessage = null;
      this.ws.onopen = null;
    }

    this.connectAttemptStarted = Date.now();
    this.ws = new WebSocket(`${this.url}?clientVersion=${clientVersion}`);

    this.ws.onclose = function () {
      webSocketEvents.trigger('close', ...arguments);
    }.bind(this);
    this.ws.onerror = function () {
      webSocketEvents.trigger('error', ...arguments);
    }.bind(this);
    this.ws.onmessage = function () {
      webSocketEvents.trigger('message', ...arguments);
    }.bind(this);
    this.ws.onopen = function () {
      webSocketEvents.trigger('open', ...arguments);
    }.bind(this);

    webSocketState.setValue(WebSocketState.CONNECTING);
  }

  onOpen() {
    if (this.connectedOnce) {
      webSocketEvents.trigger('reconnect');
    } else {
      webSocketEvents.trigger('connect');
    }

    if (this.focusReconnectStarted) {
      Analytics.sendOperationalEvent({
        actionSubject: 'socketFocus',
        action: 'renewed',
        source: 'network:socket',
      });
      this.focusReconnectStarted = 0;
    }

    this.connectedOnce = true;
    webSocketState.setValue(WebSocketState.CONNECTED);
    this.flushBuffer();
    this.resetRetries();
  }

  _triggerFailures() {
    if (webSocketState.value === WebSocketState.CONNECTING) {
      webSocketEvents.trigger('connect_failed');
    }
  }

  onClose(event?: CloseEvent) {
    webSocketEvents.trigger('disconnect', event?.reason ?? '');

    const connectivityEnhancementsIsEnabled = featureFlagClient.get(
      'fep.connectivity-enhancements',
      false,
    );

    if (event?.code === TERMINATED_SESSION_CODE) {
      // Token has been invalidated and user
      // needs to be logged out.
      let redirectUrl = '/logged-out';
      if (isEmbeddedInMSTeams()) {
        // MS Teams integration should redirect to the proper initial page, otherwise the page will not be displayable in the iframe
        redirectUrl = `/integrations/teams/tab-content?iframeSource=msteams&contentUrl=${encodeURIComponent(
          window.location.href,
        )}`;
      }

      window.location.replace(redirectUrl);
    }

    if (event?.code === DONT_COME_BACK_CODE) {
      if (!connectivityEnhancementsIsEnabled) {
        this.mustNeverReconnect = true;
      } else {
        webSocketState.setValue(WebSocketState.FORCE_DISCONNECTED);
        webSocketEvents.trigger('force_disconnected');
      }
    }

    this._triggerFailures();
    this._clearPingTimeout();
    this.reconnect(event);
  }

  onError() {
    this._triggerFailures();
    this.disconnect();
    this.reconnect();
  }

  onMessage(event: MessageEvent) {
    let parsedData;
    this._resetPingTimeout();
    if (event.data === '') {
      // This looks like a ping
      this.ws?.send('');
      return;
    }

    try {
      parsedData = JSON.parse(event.data);
    } catch (error) {}
    webSocketEvents.trigger('data', parsedData);
  }

  _shouldNotReconnect() {
    if (this.reconnectNotAttemptedReason != null) {
      this.previousReason = this.reconnectNotAttemptedReason;
    }

    this.reconnectNotAttemptedReason = (() => {
      const connectivityEnhancementsIsEnabled = featureFlagClient.get(
        'fep.connectivity-enhancements',
        false,
      );
      const forcefullyDisconnected = !connectivityEnhancementsIsEnabled
        ? this.mustNeverReconnect
        : webSocketState.value === WebSocketState.FORCE_DISCONNECTED;

      if (
        this.failedConsecutiveReconnectAttempts >=
        Socket.FAILED_CONSECUTIVE_RECONNECTS_LIMIT
      ) {
        return 'too many consecutive failures';
      } else if (forcefullyDisconnected) {
        return 'server NEVER RECONNECT code received';
      } else if (this.reconnectRateAttempts >= Socket.RECONNECT_RATE_LIMIT) {
        return 'rate limited';
      } else if (this.totalReconnects >= Socket.MAX_RECONNECTS_PER_DAY) {
        return 'max reconnects limit reached';
      } else if (this.focusReconnectStarted > 0) {
        return 'focus based attempt failed';
      }
    })();

    return this.reconnectNotAttemptedReason != null;
  }

  reconnect(event?: CloseEvent) {
    switch (webSocketState.value) {
      case WebSocketState.CONNECTED:
        this.ws?.close();
        break;
      case WebSocketState.RECONNECTING:
      case WebSocketState.WAITING_TO_RECONNECT:
      case WebSocketState.DESTROYED:
      case WebSocketState.WAITING_FOR_FOCUS:
      case WebSocketState.FORCE_DISCONNECTED:
        return;
      default:
    }

    this._setReconnectBackOff();

    const previousCallAttemptedReconnect =
      this.reconnectNotAttemptedReason == null;

    if (this._shouldNotReconnect()) {
      if (previousCallAttemptedReconnect) {
        const connectivityEnhancementsIsEnabled = featureFlagClient.get(
          'fep.connectivity-enhancements',
          false,
        );
        if (!connectivityEnhancementsIsEnabled) {
          webSocketEvents.trigger('reconnect_failed');
          webSocketState.setValue(WebSocketState.CLOSED);
          return;
        } else {
          // use the new waiting_for_focus state instead of immediately falling
          // into the redbox state. Wait for monitor to show active and try one
          // more reconnect.
          webSocketState.setValue(WebSocketState.WAITING_FOR_FOCUS);
          if (monitor.getStatus() === 'active') {
            this.onMonitorStatusActive();
          } else {
            this.monitorUnsubscribe = monitorStatus.subscribe((status) => {
              if (status === 'active') {
                this.monitorUnsubscribe?.();
                this.onMonitorStatusActive();
              }
            });
          }
          return;
        }
      }
    }

    // we have already attempted a WAITING_FOR_FOCUS event so we should
    // drop into the WAITING_FOR_USER state ... which is the old redbox
    // state
    if (this.focusReconnectStarted) {
      webSocketEvents.trigger('waiting_for_user');
      webSocketState.setValue(WebSocketState.WAITING_FOR_USER);
      return;
    }

    webSocketState.setValue(WebSocketState.WAITING_TO_RECONNECT);

    if (this.failedConsecutiveReconnectAttempts === 0) {
      this.currentReconnectDelay = calculateReconnectDelay(event);
    }

    this._reconnectTimer = window.setTimeout(() => {
      this._reconnectTimer = null;
      this.reconnectNow();
    }, this.currentReconnectDelay);

    this.totalReconnects++;
    this.failedConsecutiveReconnectAttempts++;
    this.reconnectRateAttempts++;

    this.currentReconnectDelay = Math.min(
      2 * this.currentReconnectDelay,
      Socket.MAX_RECONNECT_DELAY,
    );
  }

  onMonitorStatusActive() {
    if (!this.focusReconnectStarted) {
      Analytics.sendOperationalEvent({
        actionSubject: 'socketFocus',
        action: 'started',
        source: 'network:socket',
      });
      this.focusReconnectStarted = Date.now();
      this.reconnectNow();
    }
  }

  // this is a helper function that does the meat of a reconnection and should only
  // be called outside of the reconnect flow when a user triggers a manual reconnect
  // or when we are in the waiting_for_focus state and Monitor has detected the user
  // is active
  reconnectNow() {
    this.connect();
    webSocketState.setValue(WebSocketState.RECONNECTING);
    webSocketEvents.trigger('reconnecting');
  }

  // If a reconnect fails *really* quickly, we assume it's due to not having a connection
  // In this case, we can adjust the token buckets back down as we're not taxing the backend
  // This gives people more chance to re-connect while their wifi is connecting.
  _adjustTokenBuckets() {
    const fastFailure = this.connectAttemptStarted >= Date.now() - 20;
    if (
      webSocketState.value === WebSocketState.RECONNECTING &&
      (!navigator.onLine || fastFailure)
    ) {
      this.totalReconnects = Math.max(this.totalReconnects - 1, 0);
      this.failedConsecutiveReconnectAttempts = Math.max(
        this.failedConsecutiveReconnectAttempts - 1,
        0,
      );
      this.reconnectRateAttempts = Math.max(this.reconnectRateAttempts - 1, 0);
      this.currentReconnectDelay = this.currentReconnectDelay / 2;
    }
  }

  disconnect() {
    if (webSocketState.value === WebSocketState.DESTROYED) {
      return;
    }

    this._clearPingTimeout();
    this._adjustTokenBuckets();

    const state = webSocketState.value;
    // This needs to happen before @onClose, or we infinitely recurse
    webSocketState.setValue(WebSocketState.CLOSED);

    switch (state) {
      case WebSocketState.CONNECTED:
      case WebSocketState.CONNECTING:
      case WebSocketState.RECONNECTING:
      case WebSocketState.WAITING_FOR_USER:
        this.ws?.close();
        // A client-initiated close doesn't trigger the handler
        return this.onClose();
      case WebSocketState.WAITING_TO_RECONNECT:
        if (this._reconnectTimer) clearTimeout(this._reconnectTimer);
        break;
      default:
    }
  }

  send(data: string) {
    if (webSocketState.value === WebSocketState.CONNECTED) {
      try {
        this.ws?.send(data);
      } catch (error) {
        this.buffer.push(data);
        this.onError();
      }
    } else {
      this.buffer.push(data);
    }
  }

  flushBuffer() {
    const buf = this.buffer;
    this.buffer = [];
    buf.map((data) => this.send(data));
  }

  getState() {
    return webSocketState.value;
  }

  setState(newState: WebSocketState) {
    webSocketState.setValue(newState);
  }

  destroy() {
    // Clean up all the related timers to allow this object to be GC'd
    if (this._reconnectTimer) clearTimeout(this._reconnectTimer);
    if (this._timeoutBackoff) clearTimeout(this._timeoutBackoff);
    if (this._pingTimeout) clearTimeout(this._pingTimeout);
    if (this._dailyFailsCheck) clearInterval(this._dailyFailsCheck);
    if (this._wakeUpCheck) clearInterval(this._wakeUpCheck);

    webSocketState.setValue(WebSocketState.DESTROYED);
    webSocketEvents.stopListening(webSocketEvents);
  }
}
